import { useState,  useContext } from 'react';
import getCookie from '../../../partials/cookie';
import AcceptRegulations from './AcceptRegulations';
import {CategoriesContext} from '../../../partials/Context';


function FreePhoneCall(props) {
    const [location, setLocation] = useState('');
    const categories = useContext(CategoriesContext);
    const {prywatne, firmowe} = categories || [];
    const {default_category, if_by_category, uuid} = props
    let default_category_id = null;
    let csrftoken = getCookie('csrftoken');

    let prywatne_list = [];
    let firmowe_list = [];

    

    if(prywatne) {
    prywatne.map(item => {
        prywatne_list.push(
            <option key={item.id} value={item.id}>{item.name}</option>
        )
        return prywatne_list
    })
    }   

    if(firmowe) {
    firmowe.map(item => {
        firmowe_list.push(
             <option key={item.id} value={item.id}>{item.name}</option>
        )
        return firmowe_list
    })
    }

    let all_categories = [];

    if(prywatne && firmowe) {
        all_categories = [...prywatne, ...firmowe]
    }

    if (all_categories.length>0) {

    all_categories.forEach(category => {
        const {id,slug} = category || '';
        if (slug === default_category) {
            default_category_id = id
        }
    })

    }

    const localize = () => { 
        navigator.geolocation.getCurrentPosition(function(position) {
        fetch(`/api/cities/closest/?coords=${String(position.coords.longitude)},${String(position.coords.latitude)}`).then(
            res => res.json().then(
                data => {
                    setLocation(data.name);
                }
            ))
        });
    }

    return (
    <div className="homepage-form free-phone">
        <div className="title">
            <a href="/bezplatna-konsultacja-telefoniczna/formularz-zgloszenia/">
                <img src="/media/img/home/rozmowa_ikona.png" alt="bezplatna-rozmowa-telefoniczna"/>
            </a>
            <h1>Bezpłatna rozmowa telefoniczna w&nbsp;sprawie sądowej</h1>
        </div>
        <hr></hr>
        <div>
        <form method="POST" action="/bezplatna-konsultacja-telefoniczna/formularz-zgloszenia/" className="form-horizontal" preventdefault='true'>
            <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} autoComplete="off"></input>
             {if_by_category? <input type="hidden" name="aid" value={uuid} /> : null}
            <div>
                <h2>Temat rozmowy</h2>
                <label className="label-content" htmlFor="id_subject_0">
                    <input className="radio_choose" type="radio" required id="id_subject_0" value="1" name="subject"/>
                    Złożenie pozwu sądowego (lub sprawa w sądzie)
                </label><br></br> 
                <label className="label-content" htmlFor="id_subject_1">
                    <input className="radio_choose" type="radio" id="id_subject_1" value="0" name="subject"/>
                    Wezwanie z Policji, Prokuratury, Sądu
                </label>
                <br></br>
                <label className="label-content" htmlFor="id_subject_2">
                    <input className="radio_choose" type="radio" id="id_subject_2" value="2" name="subject"/>
                    Aresztowanie, zatrzymanie
                </label><br></br>
            </div>
            <div>
                {!if_by_category? 
                <select name="category" required id="id_category">
                    <option value="">Kategoria sprawy</option>
                    <optgroup label="Prywatna">
                        {prywatne_list}
                    </optgroup>
                    <optgroup label="Firmowa">
                        {firmowe_list}
                    </optgroup>
                </select>
                : <input  name="category" required id="id_category" value={default_category_id} type='hidden'/>}
            </div>
            <div>
                <h2>Proszę o rozmowę z prawnikiem z mojego rejonu</h2>
                <div>
                    <input name="city_name" style={{maxWidth: '50%'}} id="id_city_name" type="text" className="form-control ui-autocomplete-input inline-block"autoComplete="off" placeholder="np.: Warszawa" value={location} onChange={(e)=>setLocation(e.target.value)}/>
                    <h3>
                    lub <button className="btn" onClick={localize}>zlokalizuj </button> moje położenie
                    </h3>
                </div>
            </div>
            <div>
                <h2>Dane kontaktowe</h2>
                <hr></hr>
                <div>
                    <h3 className="input-date">
                        <span>Numer telefonu</span>
                        <span className="phone-prefix">+48&nbsp;
                            <input autoComplete="on" name="phone" type="tel" id="id_phone" required pattern="^(?:\d{3}[ \-]?\d{2}[ \-]?\d{2}[ \-]?\d{2}|\d{3}[ \-]?\d{3}[ \-]?\d{3}|\d{9})$" placeholder="np. 503 309 911"/>
                        </span>
                    </h3>
                    <h3 className="input-date">
                        <span>Adres email</span>
                        <input name="email" maxLength="75" id="id_email" type="email" required placeholder="np. example@example.pl"/>
                    </h3>
                    <p className="help-block">Wyślemy informacje o prawniku, który udzielał Ci odpowiedzi, będziesz mógł z nim korespondować i wysyłać załączniki oraz zaopiniować rozmowę.
                    </p>
                </div>
                <AcceptRegulations/>
            </div>
            <button type="submit" className="btn btn-primary center-block consultation-button">Proszę o bezpłatną poradę telefoniczną</button>
        </form>
    </div>
</div>
  )
}

export default FreePhoneCall